import Immutable from 'immutable';
import {
  AssignmentInd,
  Fireplace,
  Remove,
  PriorityHigh,
  WarningAmber,
} from '@mui/icons-material';
import {
  CLOTURE,
  getFlatStatusList,
  isMainStatus,
  isSubStatus,
  getMainStatusFromSubStatus,
} from '@lba-dev/package.local-globals/caldeoType';
import { permit } from '@lba-dev/package.local-globals/restrictions';

import api from '../../../api';
import notifSystem from '../../../notifSystem';
import {
  changeStatusMiddleware,
  priseEnChargeCaldeo,
  changeType,
  dialogDeleteCaldeo,
} from '../../../actions/caldeo';

const defaultCheck = (props) => {
  const user = props.users.find((e) => e._id === props.userId);
  return (
    Immutable.List.isList(props.users) &&
    props.selected &&
    props.selected.isCaldeo &&
    user &&
    permit(user, {
      key: 'caldeoAction',
    })
  );
};

export default [
  {
    name: 'Prise en charge',
    icon: AssignmentInd,
    customVisible: (elem, props) =>
      defaultCheck(props) &&
      !props.selected.login.caldeoPrisEnCharge,
    action: (props) => priseEnChargeCaldeo(props),
  },
  {
    name: 'Changer statut Aides',
    icon: Fireplace,
    customVisible: (elem, props) => {
      const user = props.users.find((e) => e._id === props.userId);
      return (
        user &&
        defaultCheck(props, user) &&
        props.selected.login.caldeoPrisEnCharge &&
        (props.selected.caldeo?.mainStatus !== CLOTURE ||
          permit(user, { key: 'caldeoStatus' }))
      );
    },
    action: (props) =>
      changeStatusMiddleware(props, {
        title: 'Changer statut Aide',
        buttons: getFlatStatusList(),
        status: props.selected?.caldeo?.subStatus ||
          props.selected?.caldeo?.mainStatus,
        cb: (propsInner, validate, update) => {
          let statusUpdate = {};
          if (isMainStatus(validate.status)) {
            statusUpdate = {
              caldeo: {
                mainStatus: validate.status,
                subStatus: '',
              }
            };
          } else if (isSubStatus(validate.status)) {
            const mainStatus = getMainStatusFromSubStatus(validate.status);
            statusUpdate = {
              caldeo: {
                mainStatus: mainStatus?._id,
                subStatus: validate.status,
              }
            };
          }

          const finalUpdate = validate.status === CLOTURE
            ? {
              ...update,
              ...statusUpdate,
              date: {
                resolutionCaldeo: new Date(),
              },
              login: {
                resolutionCaldeo: propsInner.user._id
              }
            }
            : {
              ...update,
              ...statusUpdate,
            };

          return changeType(propsInner, validate, finalUpdate)
        },
      }),
  },
  {
    name: 'Supprimer du caldeo',
    icon: Remove,
    customVisible: (elem, props) =>
      defaultCheck(props) && !props.selected.login.caldeoPrisEnCharge,
    action: dialogDeleteCaldeo,
  },
  {
    name: (props) => props.selected?.caldeo?.problemeBloquant
      ? 'Retirer problème bloquant'
      : 'Signaler un problème bloquant',
    icon: PriorityHigh,
    customVisible: (elem, props) => (
      defaultCheck(props) &&
        props.selected.login.caldeoPrisEnCharge
    ),
    action: (props) => {
      const newValue = !props.selected?.caldeo?.problemeBloquant;
      return api.interventions.patch(props.selected._id, {
        caldeo: {
          problemeBloquant: newValue
        }
      }).then(() => {
        notifSystem.success(
          'Opération réussie',
          newValue ? 'Problème bloquant signalé' : 'Problème bloquant retiré'
        );
      }).catch(e => notifSystem.error(e.name, e.message));
    },
  },
  {
    name: (props) => props.selected?.caldeo?.litigeSignale
      ? 'Retirer litige signalé'
      : 'Signaler un litige',
    icon: WarningAmber,
    customVisible: (elem, props) => (
      defaultCheck(props) &&
        props.selected.login.caldeoPrisEnCharge
    ),
    action: (props) => {
      const newValue = !props.selected?.caldeo?.litigeSignale;
      return api.interventions.patch(props.selected._id, {
        caldeo: {
          litigeSignale: newValue
        }
      }).then(() => {
        notifSystem.success(
          'Opération réussie',
          newValue ? 'Litige signalé' : 'Litige retiré'
        );
      }).catch(e => notifSystem.error(e.name, e.message));
    },
  },
];
